import { render, staticRenderFns } from "./MassWhatsappSection.vue?vue&type=template&id=7df20b80&scoped=true"
import script from "./MassWhatsappSection.vue?vue&type=script&lang=js"
export * from "./MassWhatsappSection.vue?vue&type=script&lang=js"
import style0 from "./MassWhatsappSection.vue?vue&type=style&index=0&id=7df20b80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df20b80",
  null
  
)

export default component.exports